export const WHATSAPP_NUMBER = '+962786864323'
export const IMAGE_QUALITY = 0.92
